// jiboomba URL
// const BASE_URL = "https://staging.syscorp.in/api/v1/jiboomba";
// const BASE_URL = "https://iccpanel.com/api/v1/jiboomba";
// const BASE_URL = "https://iccpanel.com/api/v1/betwin";
// const BASE_URL = "https://iccpanel.com/api/v1/betwin";
//
// const BASE_URL = "https://staging.syscorp.in/api/v1/test";
// const BASE_URL = "https://iccpanel.com/api/v1/1860bet";
const BASE_URL = "https://staging.iccpanel.com/api/v1/1860bet";

// const BASE_URL = "https://iccpanel.com/api/v1/1860bet";

export default BASE_URL;
